<template>
    <div>
        <div class="fs-desc">
            Kérjük, végezze el a gyorsított regisztrációt, csak pár lépés!
        </div>

        <ValidationObserver ref="form" slim v-slot="{ invalid }">
            <div class="popup-form form">
                <ValidationProvider
                    name="E-mail cím"
                    rules="required|email"
                    v-slot="{ errors, classes }"
                    slim
                    mode="eager"
                >
                    <div class="d-table w-100 mb-30px">
                        <div :class="classes">
                            <div>Email cím:</div>
                            <input
                                type="email"
                                placeholder="E-mail cím"
                                class=""
                                v-model="email"
                                inputmode="email"
                                data-hj-allow
                            />
                        </div>
                        <span class="error_message error_message--broke">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    name="Születési Idő"
                    rules="required|birth_date:18"
                    v-slot="{ errors, classes }"
                    slim
                    mode="eager"
                >
                    <div class="d-table w-100 mb-30px">
                        <div>Születési idő:</div>
                        <div :class="classes">
                            <input
                                type="date"
                                v-model="birth_date"
                                max="9999-12-31"
                                data-hj-allow
                            />
                        </div>
                        <span class="error_message error_message--broke">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    name="Jelszó"
                    rules="required|password"
                    v-slot="{ errors, classes }"
                    slim
                    mode="eager"
                >
                    <div class="d-table w-100 mb-30px">
                        <div :class="classes">
                            <div>Jelszó:</div>
                            <input type="password" placeholder="Jelszó" v-model="password" inputmode="text"
                                   data-hj-allow/>
                        </div>
                        <span class="error_message error_message--broke">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    name="Jelszó ismétlés"
                    rules="required|password|confirm:@Jelszó"
                    v-slot="{ errors, classes }"
                    slim
                >
                    <div class="d-table w-100 mb-30px">
                        <div :class="classes">
                            <div>Jelszó ismétlés:</div>
                            <input
                                type="password"
                                placeholder="Jelszó ismétlés"
                                v-model="password_repeat"
                                inputmode="text"
                                data-hj-allow
                            />
                        </div>
                        <span class="error_message error_message--broke">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    name="Adatkezelés"
                    :rules="{ required: { allowFalse: false } }"
                    v-slot="{ errors, classes }"
                    slim
                    mode="eager"
                >
                    <div class="col-w100-chbox chbox_style-wrapper mb-15px d-flex flex-column">
                        <div :class="[classes]" class="d-flex checkbox-field">
                            <input type="checkbox" id="privacyPolicy" class="field" v-model="terms" data-hj-allow/>
                            <span class="chbox_style"></span>
                            <label for="privacyPolicy">
                                Elolvastam és elfogadom az
                                <a href="/adatvedelem" target="_blank">Adatkezelésről</a>
                                szóló tájékoztatóban foglaltakat.
                            </label>
                        </div>
                        <span class="error_message error_message--broke">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <span class="d-flex error_message error_message--broke justify-center mb-15px mt-12px" v-if="error">
					{{ error }}
				</span>

                <LoadingButton
                    class="btn btn-blue m-auto"
                    text="Regisztráció"
                    :disabled="invalid"
                    @click="handleRegistration"
                    :loading="getLoading"
                />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import LoadingButton from "@/components/elements/LoadingButton.vue";

export default {
    mounted() {
        this.email = this.getSimpleRegistrationEmail;
    },
    components: {LoadingButton},
    props: {
        minimal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            email: null,
            password: null,
            password_repeat: null,
            terms: null,
            birth_date: null,
            error: null,
        };
    },
    computed: {
        ...mapGetters(['getLoading']),
        ...mapGetters('auth',['getSimpleRegistrationEmail']),
    },
    methods: {
        ...mapActions('auth', ['finalizeSimpleRegister']),
        ...mapMutations(['showPopup']),
        async handleRegistration() {
            this.$refs.form.validate().then(async success => {
                if (success) {
                    const response = await this.finalizeSimpleRegister({
                        email: this.email,
                        password: this.password,
                        terms: this.terms,
                        birth_date: this.birth_date,
                        hash: this.$route.params.hash,
                        insurer_uuid: this.$route.params.insurer_uuid,
                    });
                    if (response !== true) {
                        this.$refs.form.setErrors(response.errors);
                    } else {
                        this.$emit('success');
                        this.showPopup(null);
                    }
                }
            });
        },
    },
};
</script>
